<template>
 <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;">        
        <v-btn class="adminLibelleBtn"  :to="{name:'EditAdminMission',params:{itemid:item.id}}" flat :title="$t('Admin.AdminMission.List.ReachAdminMissionTooltip')" >{{item.MIS_LIBELLE}}</v-btn>              
      </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbMission } from '@/models/alodb/AloDbMission';


@Component({
  name: 'AdminAdminMissionListLine',   
   props: {  
     item:{
       type:AloDbMission,
       required:true
     }  
  }
})
export default class AdminAdminMissionListLine extends Vue {
  item!:AloDbMission
  
  
}
</script>